module.exports = __webpack_public_path__ + "static/media/video2.ee77d312.mp4";